import o from "./highrise1528.mjs";
import r from "./highrise1310.mjs";
var p = o(r, "Map");
export {
  p as default
};
